import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header3/Header3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import srImg from "../../images/services/service_image_8.webp";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import WhyUs from "../AboutUsPage/WhyUs";
import SEO from "../../components/seo/SEO";

const ServicePage = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <SEO
        title="Chartered Accountants Delhi – Tax & IFRS | Binod Verma & Co."
        description="Reliable CA firm in Delhi NCR offering tax filing, bookkeeping, compliance, and financial advisory for individuals, startups, and NGOs."
        keywords="CA Firm Delhi NCR, Tax Filing Delhi, Bookkeeping Services Delhi, Chartered Accountant Delhi, NGO Audit Delhi NCR, Startup CA Services Delhi, Compliance Consultant Delhi"
        canonical="https://www.binodverma.com/"
        ogImage="https://ufs-net.s3.ap-south-1.amazonaws.com/demoInterview/og-image.jpg"
        schemaMarkup={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "AccountingService",
              name: "Binod Verma & Co.",
              image:
                "https://ufs-net.s3.ap-south-1.amazonaws.com/demoInterview/og-image.jpg",
              description:
                "Chartered Accountant in Delhi NCR specializing in taxation, GST, audits, NGOs & accounting services.",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Laxmi Nagar",
                addressLocality: "Delhi",
                addressRegion: "Delhi",
                postalCode: "110092",
                addressCountry: "India",
              },
              areaServed: ["Delhi", "Noida", "Gurgaon"],
              url: "https://www.binodverma.com",
            },
            {
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "Which is the best CA firm in Delhi for startups?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Binod Verma & Co. provides tax filing, GST, and audit solutions tailored for Delhi-based startups.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Do you provide NGO audit services in Noida?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, we specialize in NGO and society audits in Noida with compliance-focused services.",
                  },
                },
              ],
            },
          ],
        }}
      />
      <Header />
      <main className="page_content about-page">
        <PageTitle
          pageTitle={"Our Services"}
          pagesub={"Services "}
          pageTop={"Our Main"}
        />
        <section className="about_section section_space bg-light">
          <div className="container">
            <div className="row align-items-center justify-content-lg-between">
              <div className="col-lg-5 order-lg-last">
                <div className="team_cartoon_image">
                  <img src={srImg} alt="Service Cartoon" />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="about_content">
                  <div className="heading_block">
                    <div className="heading_focus_text">
                      We Are
                      <span className="badge bg-secondary text-white">
                        Your Trusted Financial Partners 😊
                      </span>
                    </div>
                    <h1 className="heading_text">
                      Comprehensive Accounting & Tax Solutions for Your Growth
                    </h1>
                    <p className="heading_description mb-0">
                      At Binod Verma & Co., we recognize that every business has
                      unique financial needs. Our expert team provides
                      customized accounting, tax, and compliance solutions to
                      help businesses stay ahead. Explore our wide range of
                      services, from income tax consultancy to GST compliance,
                      audit & assurance, financial management, and business
                      advisory.
                    </p>
                  </div>
                  <Link onClick={ClickHandler} to={"/contact"} className="btn">
                    <span className="btn_label" data-text="Contact Us">
                      Contact Us
                    </span>
                    <span className="btn_icon">
                      <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ServiceSection />
        <div className="pt-130"></div>
        <WhyUs />
      </main>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ServicePage;
